import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationRU from './locales/ru.json';
import translationEN from './locales/en.json';
import translationES from './locales/es.json';

const resources = {
  ru: {
    translation: translationRU
  },
  en: {
    translation: translationEN
  },
  es: {
    translation: translationES
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'es', // Default to Spanish if browser language is not RU or EN
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng'
    },
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false
    }
  });

// Custom language detection: if browser language is not ru or en, use es
const detectedLang = navigator.language.toLowerCase();
if (!detectedLang.startsWith('ru') && !detectedLang.startsWith('en')) {
  i18n.changeLanguage('es');
}

export default i18n;
